import { editStore, settingsStore } from '../stores';
import features from '../components/features';
import { resolveStyle } from './styleCatalog';

export function launchStyle(item) {
  const resolved = resolveStyle(item);
  if (!resolved) return false;
  const feature = features.find(f => f.id === resolved.feature);
  if (!feature || feature.disabled) return false;
  if (resolved.style) settingsStore.update(s => ({ ...s, selectedStyle: resolved.style.name,
    selectedStyleBackend: resolved.style.backend, selectedStyleBackendName: resolved.style.backendName }));
  editStore.update(s => ({ ...s, selectedFeature: feature }));
  document.dispatchEvent(new CustomEvent('navigate', { detail: 'editorv2' }));
  return true;
}
